
<h1 mat-dialog-title>Assign Product Managers </h1>
<p class="dialogSubheading">Enter one or more product managers to be notified to add accruals for this program</p>
<div [formGroup]="programForm">
<mat-form-field class="example-chip-list">
    <mat-chip-grid #chipList aria-label="Productmgr selection">
        <mat-chip-row
          *ngFor="let Productmgr of data.prodmgrs"
          (removed)="remove(Productmgr)">
          {{Productmgr}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input
          placeholder="Product Manager(s)..."
          #ProductmgrInput
          formControlName="ProductmgrCtrl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="add($event)">
      </mat-chip-grid>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)" >       
        <mat-option *ngFor="let Productmgr of filteredProductmgrs" [value]="Productmgr">
          {{Productmgr.name}}
        </mat-option>
      </mat-autocomplete>
      

</mat-form-field>


</div>
<div class="dialogButtons">
    <button mat-raised-button class="functional-button-dark" (click)="onReleaseProgramforAccruals()"> Release Program for Accruals</button>
    <button mat-raised-button class="functional-button" (click)="Cancel()" > Cancel</button>
</div>